import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AjaxContext, AppContext, formatListData, EMPTY_ARRAY, UserContext } from 'commons-ui';
import { UserDetailsContext } from 'context/userDetails';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { IForm60Data } from './types';

const useService = () => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);
	const { user } = useContext(UserContext);
	const { permissionsConfig } = useContext(UserContext);
	const getForm60Details = useCallback(async () => {
		const permission = _find(permissionsConfig, { actionName: ACTION.getForm60Details });
		const result = await postData({
			endpoint: `/dashboard/getForm60Details/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.kycDetails}-getForm60Details`,
			queryParams: {
				appName
			},
			body: { uid },
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});
		const data = _get(result, ['data', 'data'], EMPTY_ARRAY);
		const listData = formatListData(data);

		return { rowCount: listData.length, data: listData };
	}, []);

	const submitForm60Details = useCallback(async (form60Data: IForm60Data) => {
		const result = await postData({
			endpoint: `/dashboard/submitForm60Details/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.kycDetails}-submitForm60Details`,
			queryParams: {
				appName
			},
			body: { uid, agentEmail: user?.email, ...form60Data }
		});

		return result;
	}, []);

	return { getForm60Details, submitForm60Details };
};

export default useService;
